import React, { useState, useEffect, Children } from 'react';
import Compressor from 'compressorjs';

export const FileInput = (props) => {
    const [previewSrc, setPreviewSrc] = useState("")
    const [compressedFile, setCompressedFile] = useState(null);

    const handleCompressedUpload = (e) => {
        const image = e.target.files[0];
        e.target.value = null
        new Compressor(image, {
            quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
                // compressedResult has the compressed file.
                // Use the compressed file to upload the images to your server.        
                // setCompressedFile(compressedResult)

                convert64(compressedResult)
            },
        });
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const convert64 = async (image) => {
        var converted = await toBase64(image)
        
        setPreviewSrc(converted)
        props.onChange({
            converted,
            // file: e
        })
    }

    return (
        <div className="">
            <label
                htmlFor={props.name}
                className="text-center flex items-center flex-col"
            >
                <p className='text-carching-pink'>{props.label}</p>
                {previewSrc.length > 0 ? (
                    <div
                        className='bg-center bg-no-repeat bg-contain w-[80px] h-[80px] rounded-2xl shadow-xl'
                        style={{ backgroundImage: `url(${previewSrc})` }}
                    >
                    </div>
                ) : (
                    <div className="shadow-xl p-[15px] rounded-2xl w-[80px] h-[80px] flex flex-col align-center justify-center">
                        <p className='text-xl text-carching-pink'>+</p>
                    </div>
                )}
            </label>

            <input
                className="hidden"
                type="file"
                accept="image/*"
                capture="camera"
                id={props.name}
                onChange={(e) => handleCompressedUpload(e)}
            />
        </div>
    );
};

export const SelectInput = (props) => {
    return(
        <div className={`flex-col flex ${props.className}`}>
            <label for={props.id} className="text-xs text-carching-pink" >{props.title}</label>
            <select 
                {...props}
                className="border-2 border-carching-pink px-2 py-1 rounded-2xl"
            >
                {props.children}
            </select>
        </div>
    )
}